"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BreadcrumbsUpdater = void 0;
const tslib_1 = require("tslib");
const catalog_core_1 = require("@tableau/catalog-core");
const react_1 = tslib_1.__importDefault(require("react"));
function BreadcrumbsUpdater({ breadcrumbs }) {
    const uiActions = (0, catalog_core_1.useUIActions)();
    return react_1.default.createElement(BreadcrumbsUIActionsUpdater, { breadcrumbs: breadcrumbs, uiActions: uiActions });
}
exports.BreadcrumbsUpdater = BreadcrumbsUpdater;
class BreadcrumbsUIActionsUpdater extends react_1.default.Component {
    componentDidMount() {
        this.updateBreadcrumbs();
    }
    componentDidUpdate(prevProps) {
        if (this.props.breadcrumbs !== prevProps.breadcrumbs || this.props.uiActions !== prevProps.uiActions) {
            this.updateBreadcrumbs();
        }
    }
    updateBreadcrumbs() {
        const breadcrumbs = this.props.breadcrumbs;
        this.props.uiActions.updateBreadcrumbs(breadcrumbs);
        const breadcrumbsLength = breadcrumbs.length;
        if (breadcrumbsLength > 0) {
            const lastBreadcrumb = breadcrumbs[breadcrumbsLength - 1];
            const lastBreadcrumbHref = lastBreadcrumb.href;
            if (lastBreadcrumbHref) {
                this.props.uiActions.updateBreadcrumbHref(lastBreadcrumbHref);
            }
        }
    }
    render() {
        return null;
    }
}
//# sourceMappingURL=BreadcrumbsUpdater.js.map